import { QuoteCard } from '../../../components/Cards/QuoteCard/QuoteCard';
import { ContinuousCarousel } from '../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { GetSingleSpecies_entry_speciesTips_edges_node as ISTip } from '../../../interfaces/graphql';

interface IProps {
  tipsList: ISTip[];
}

export const TipsSection = ({ tipsList }: IProps) => {
  return (
    <div data-testid="TipsSection">
      <ContinuousCarousel dataTestId="species-tips" title="Tips from our Pro anglers">
        {tipsList.map(({ tip, userDisplayName, externalId, user, userDescription }) => (
          <QuoteCard
            key={`water-reviews-${externalId}`}
            bodyText={tip}
            username={userDisplayName}
            userImageUrl={user.avatar?.url}
            userDescription={userDescription}
          />
        ))}
      </ContinuousCarousel>
    </div>
  );
};
